import * as types from '../constants';

const initialState = {
  probabiliMethode: {},
  probabiliMethodes: {},
};

function reverseAwayTeam(lineups) {
  const reversedLineups = lineups;
  if (lineups && lineups.formationModule) {
    const reversedSchema = lineups.formationModule.reverse();
    Object.assign(reversedLineups.formationModule, reversedSchema);
  }
  return reversedLineups;
}

export default function probabiliMethodeReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PROBABILI_SUCCESS:
      if (typeof state.probabiliMethodes[action.widgetId] === 'undefined') {
        state.probabiliMethodes[action.widgetId] = { homeTeam: {}, awayTeam: {} };
      }
      return {
        ...state,
        probabiliMethodes: {
          ...state.probabiliMethodes,
          [action.widgetId]: {
            ...state.probabiliMethodes[action.widgetId],
            homeTeam: {
              ...state.probabiliMethodes[action.widgetId].homeTeam,
              teamId: action.data.squadHomeId,
            },
            awayTeam: {
              ...state.probabiliMethodes[action.widgetId].awayTeam,
              teamId: action.data.squadAwayId,
            },
          },
        },
      };
    case types.GET_PROBABILI_HOME_SUCCESS:
      return {
        ...state,
        probabiliMethodes: {
          ...state.probabiliMethodes,
          [action.widgetId]: {
            ...state.probabiliMethodes[action.widgetId],
            homeTeam: Object.assign({}, state.probabiliMethodes[action.widgetId].homeTeam, action.data),
          },
        },
      };
    case types.GET_PROBABILI_AWAY_SUCCESS:
      return {
        ...state,
        probabiliMethodes: {
          ...state.probabiliMethodes,
          [action.widgetId]: {
            ...state.probabiliMethodes[action.widgetId],
            awayTeam: Object.assign({}, state.probabiliMethodes[action.widgetId].awayTeam, reverseAwayTeam(action.data)),
          },
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/probabili.js